import React, { useCallback, useEffect, useState } from 'react';
import { TextField } from '@mui/material';

export default function OrderFormItemDescriptionField({
  formItemId,
  committedDescription,
  disabled,
  placeholder,
  sx,
  onDraftInput,
  onCommit,
}) {
  const [text, setText] = useState(() =>
    committedDescription == null ? '' : String(committedDescription)
  );

  useEffect(() => {
    setText(committedDescription == null ? '' : String(committedDescription));
  }, [committedDescription]);

  const handleChange = useCallback(
    (e) => {
      const v = e.target.value;
      setText(v);
      onDraftInput(formItemId, v);
    },
    [formItemId, onDraftInput]
  );

  const handleBlur = useCallback(() => {
    onCommit(formItemId, text);
  }, [formItemId, text, onCommit]);

  return (
    <TextField
      size="small"
      placeholder={placeholder}
      value={text}
      disabled={disabled}
      onChange={handleChange}
      onBlur={handleBlur}
      multiline
      minRows={1}
      maxRows={4}
      sx={[
        sx,
        {
          '& .MuiInputBase-root': {
            alignItems: 'flex-start',
          },
          '& .MuiInputBase-inputMultiline': {
            py: { xs: '8px', md: '8px' },
            px: { xs: '11px', md: '10px' },
            lineHeight: 1.43,
          },
        },
      ]}
    />
  );
}
